import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "px-3 mt-4" }
const _hoisted_2 = { class: "flight-pack-text text-grey-900" }
const _hoisted_3 = { class: "d-flex align-items-center gap-2" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = {
  key: 0,
  class: "mx-2 text-grey-900"
}
const _hoisted_7 = { class: "d-flex align-items-center me-1 flex-column" }
const _hoisted_8 = {
  width: "20",
  height: "20",
  class: "icon me-1"
}
const _hoisted_9 = ["xlink:href"]
const _hoisted_10 = { class: "package-label" }
const _hoisted_11 = { class: "d-flex justify-content-start align-items-center" }
const _hoisted_12 = {
  key: 0,
  class: "d-flex align-items-center justify-content-center prestation-discount-container f bg-primary-orange ms-1 ms-xl-3"
}
const _hoisted_13 = { class: "prestation-discount subcaption-strong text-primary-white px-2 py-1 text-nowrap" }

import { computed, onMounted, ref } from "vue"
import { useStore } from "vuex"

// Computed
import packagesToDisplay from "@/vue/planning/computed/packagesToDisplay"

// Config
import packageCompositionConfig from "@/config/packageCompositionConfig"
import { type PackageComponent } from "@/config/packageCompositionConfig"

// Logic
import { isCS } from "@/vue/planning/logic/cs"
import getPackageComposition from "@/vue/planning/logic/getPackageComposition"

// Utils 
import { hasChangedTransportType } from "@/utils/transportation"
import { airportCodeMap } from "@/config/airportCodeMap"
import flightPackCode from "@/config/flightPackCode"
import transportPackCode from "@/config/transportPackCode"
import getSiteFromDomain from "@/vue/planning/logic/getSiteFromDomain";
import displayPrice from "@/displayPrice/displayPrice"
import trainPackCode from "@/config/trainPackCode"
import { transportPacks } from "@/config/transportPackagePriorities"
import { Transport } from "@/types"

type PackPromo = { perCent: number; perValue: number }



export default /*@__PURE__*/_defineComponent({
  __name: 'flightPackages',
  setup(__props) {

const store = useStore()

// Reactive data
const localPackagesToDisplay = ref<{ codePackage: string, packageId?: string }[]>([])

// Computed
const packCode = computed<string>(() => store.state.packCode)
const isLocaleNL = computed<boolean>(() => store.getters.isLocaleNL)
const isLocaleEN = computed<boolean>(() => store.getters.isLocaleEN)
const content = computed<Record<string, string>>(() => store.state.content)
const availablePackCodes = computed<{ codePackage: string }[]>(() => store.getters.availablePackCodes)
// const maxPromosFromAvailablePackages = computed(() => store.getters.maxPromosFromAvailablePackages)

const promoString = computed(() => {
	const promoString: Map<string, string> = new Map();
	availablePackCodes.value.forEach((packObj: { codePackage: string, packageId?: string }) => {
		// console.log("XXX packObj.codePackage", packObj.codePackage, "promos.value[packObj.codePackage as keyof typeof promos.value]", promos.value[packObj.codePackage as keyof typeof promos.value])
		if (getSiteFromDomain(window.location.hostname) === "www.uk.travelski.com") {
			promoString.set(packObj.codePackage, `-${displayPrice(promos.value[packObj.codePackage as keyof typeof promos.value].perValue*100, store.getters.locale)}`);
		} else {
			promoString.set(packObj.codePackage, `-${promos.value[packObj.codePackage as keyof typeof promos.value].perCent}%`);
		}
	});
	return promoString;
});

const effectivePackagesToDisplay = computed(() => {
	
	let result: { codePackage: string, packageId?: string }[] = [];

	if (localPackagesToDisplay.value && localPackagesToDisplay.value.length > 0) {
		result = localPackagesToDisplay.value;
	} else if (packagesToDisplay.value && packagesToDisplay.value.length > 0) {
		result = packagesToDisplay.value;
	} else if (availablePackCodes.value && availablePackCodes.value.length > 0) {
		result = availablePackCodes.value;
	}

	return result.filter((pack: { codePackage: string }) => store.getters.transportv2 === null || (flightPackCode.includes(pack.codePackage) && store.getters.transportv2 === Transport.FLIGHT) || (trainPackCode.includes(pack.codePackage) && store.getters.transportv2 === Transport.TRAIN));
})

// Methods
const getPackageCompositionConfig = (packageCode: string) => {
	const composition = packageCompositionConfig[packageCode]?.components || []
	return composition
}

const getContentKey = (component: PackageComponent) => {
	// Use short version for Dutch and English locales
	let keyToUse = component.contentKey
	if ((isLocaleNL.value || isLocaleEN.value) && component.contentKeyShort) {
		keyToUse = component.contentKeyShort
	}
	return content.value[keyToUse]
}

const handlePackageChange = async (packObj: {
	codePackage: string
	packageId: string
}) => {
	const isTransportPack = transportPacks.includes(packObj.codePackage)
	if (packCode.value === packObj.codePackage) {
		store.dispatch("setPackagesMobileDropdownOpen", false)
		return
	}

	// First update package composition if needed
	if (packObj.codePackage !== "HS" && !isCS(packObj)) {
		await getPackageComposition(store)
	}

	// const changedTransportType = hasChangedTransportType(store.state.packCode, packObj.codePackage, isTransportPack)

	// Then update the package
	await store.dispatch("setPackage", packObj.codePackage)
	store.state.packageId = packObj.packageId

	// Check if the new package is a flight pack or train pack and select the appropriate origin
	// const isFlightPackage = flightPackCode.includes(packObj.codePackage)
	// const isTrainPackage = trainPackCode.includes(packObj.codePackage)
	// if (isFlightPackage) {
	// 	// store.commit("setTransportationSelected", true)
	// 	// Always select the first available origin when switching to a flight package tab
	// 	await store.dispatch("selectDefaultFlightOrigin", { overwrite: true, forceFlightPackCode: true })
	// } else if (isTrainPackage) {
	// 	// store.commit("setTransportationSelected", true)
	// 	// Always select the default train origin when switching to a train package tab
	// 	await store.dispatch("selectDefaultTrainOrigin", { overwrite: true, forceTrainPackCode: true })
	// // } else if (isTransportPack) {
	// // 	// store.commit("setTransportationSelected", true)
	// // 	const overwrite = store.state.flightOrigin === airportCodeMap.get("None")?.name || changedTransportType
	// // 	await store.dispatch("selectDefaultFlightOrigin", overwrite)
	// } else {
	// 	store.commit("setTransportationSelected", false)
	// 	store.commit("setFlightOrigin", airportCodeMap.get("None")?.name)
	// }

}


const promos = computed((): Record<string, PackPromo> => {
	const rawData = store.getters.getWiypCallByFamilyComposition(store.state.participants.join('-')) || {};
	const promoObject: Record<string, PackPromo> = {};
	if (rawData && typeof rawData === 'object') {
		availablePackCodes.value.forEach((packObj: { codePackage: string, packageId?: string }) => {
			// We NEED to load prestIdFusion/prestIdSource from prestmaps but we do not have them
		
			let maxPromo: PackPromo = { perCent: 0, perValue: 0 };
			// Loop through all values (usually just one key, but future-proof)
			// { "LON": { "PFF": {"1000000032": {wiypPrices: [{publicPriceWiyp: 100, sellingPriceWiyp: 90}]}}}}
			Object.values(rawData).forEach((valueOriginObject: any) => {
				/* 	"PFF": { "1000000031": { "wiypPrices": [{"sellingPriceWiyp": 5233.55,"publicPriceWiyp": 4951.33},{"sellingPriceWiyp": 4115.29,"publicPriceWiyp": 3916.55}]}}	*/
				Object.entries(valueOriginObject).forEach(([packageCode, valuePackageObject]: [string, any]) => {
					/* "1000000031": { "wiypPrices": [{"sellingPriceWiyp": 5233.55,"publicPriceWiyp": 4951.33},{"sellingPriceWiyp": 4115.29,"publicPriceWiyp": 3916.55}]} */
					if ( packageCode === packObj.codePackage && valuePackageObject && typeof valuePackageObject === 'object' ) {
						Object.values(valuePackageObject).forEach((valuePackageIdObject: any) => {
							/* "wiypPrices": [{"sellingPriceWiyp": 5233.55,"publicPriceWiyp": 4951.33},{"sellingPriceWiyp": 4115.29,"publicPriceWiyp": 3916.55}] */
							if (valuePackageIdObject && Array.isArray((valuePackageIdObject as any).wiypPrices)) {
								(valuePackageIdObject as any).wiypPrices.forEach((promoPrice: any) => {
									// console.log("XXX promoPrice", JSON.stringify(promoPrice, null, 2))
									// need to check that prestId is in variant
									if (
										typeof promoPrice.publicPriceWiyp === 'number' &&
										typeof promoPrice.sellingPriceWiyp === 'number' &&
										promoPrice.publicPriceWiyp !== 0
									) {
										const promo = Math.round(
											((promoPrice.publicPriceWiyp - promoPrice.sellingPriceWiyp) /
												promoPrice.publicPriceWiyp) *
												100
										);
										if (promo > maxPromo.perCent) {
											maxPromo = { perCent: promo, perValue: Math.floor(promoPrice.publicPriceWiyp - promoPrice.sellingPriceWiyp)};
										}
									}
								});
							}	
						});
					}
				});
			});	
			promoObject[packObj.codePackage] = maxPromo;		
		})
	}

	return promoObject;
})



const showBadge = (codePackage: string) => {
	if (codePackage === 'HS') return false;
	if (getSiteFromDomain(window.location.hostname) === "www.uk.travelski.com") {
		return promos.value[codePackage as keyof typeof promos.value] && promos.value[codePackage as keyof typeof promos.value].perValue >= 100;
	}
	return promos.value[codePackage as keyof typeof promos.value] && promos.value[codePackage as keyof typeof promos.value].perCent > 5;
}



onMounted(() => {
	if (flightPackCode.includes(packCode.value) && store.state.participants.length > 9) {
		store.dispatch("setParticipants", store.state.participants.slice(0, 9));
	}
	if ((!packagesToDisplay.value || packagesToDisplay.value.length === 0) &&
		availablePackCodes.value && availablePackCodes.value.length > 0) {
		localPackagesToDisplay.value = [...availablePackCodes.value] as { codePackage: string, packageId: string }[]
	}
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(content.value.flight_select_pack), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(effectivePackagesToDisplay.value, (packObj) => {
        return (_openBlock(), _createElementBlock("div", {
          key: packObj.codePackage,
          onClick: ($event: any) => (handlePackageChange(packObj as { codePackage: string, packageId: string })),
          class: _normalizeClass(["package-tab d-flex align-items-center justify-content-between p-3 col", packCode.value === packObj.codePackage ? 'active' : 'text-grey-900'
					])
        }, [
          _createElementVNode("span", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getPackageCompositionConfig(
						packObj.codePackage
					), (component, componentIndex) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: `${packObj.codePackage}-${componentIndex}`
              }, [
                (componentIndex > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "+"))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_7, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_8, [
                    _createElementVNode("use", {
                      "xlink:href": `#___icon___${component.icon}`
                    }, null, 8, _hoisted_9)
                  ])),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(getContentKey(component)), 1)
                ])
              ], 64))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_11, [
            (
							packObj.codePackage !== 'HS' 
							&& showBadge(packObj.codePackage)
							)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(promoString.value.get(packObj.codePackage)), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ], 10, _hoisted_4))
      }), 128))
    ])
  ]))
}
}

})